// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___34rxN","container_1":"container_1___3efNM","container_2":"container_2___3R2s1"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Recipe/styles.module.scss
// module id = 733
// module chunks = 0